module.exports = __webpack_public_path__ + "img/32.17359e1b.png";